export default __webpack_public_path__ + "static/media/guiaIphone2.49c2dc26.png";